/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BossIcon24Solid = forwardRef('People1BossIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { d: "M2.179 20.01c.673-3.486 3.144-4.96 5.636-5.576l1.45 3.316L8.027 22H4c-1.105 0-2.03-.906-1.821-1.99Z" }),
        React.createElement("path", { d: "m14.734 17.75 1.451-3.316c2.492.617 4.963 2.09 5.636 5.575C22.031 21.095 21.105 22 20 22h-4.026l-1.24-4.25Z" }),
        React.createElement("path", { d: "m11.219 17.125-1.346 5.92a.781.781 0 0 0 .762.955h2.73a.781.781 0 0 0 .762-.954l-1.346-5.921c.906-.76 1.235-1.41 1.481-2.671a.383.383 0 0 0-.38-.454h-3.757a.387.387 0 0 0-.381.461c.247 1.236.494 1.826 1.475 2.664Z" })));
});
